<template>
  <main v-if="isAdaptativeLearning">
    <Button
      class="btn-outline p-button-sm flex gap-2"
      @click.prevent="onToggleFilter($event)"
    >
      <v-icon name="md-playlistplay-twotone" />
      <span class="hidden md:flex">{{
        $t("labels.generic", {
          pt: "Materiais assistidos",
          en: "Watched materials",
        })
      }}</span>
    </Button>

    <OverlayPanel
      ref="panel"
      style="width: 450px; z-index: -1"
      :breakpoints="{ '960px': '75vw' }"
    >
      <section>
        <p class="mb-5 font-bold">{{ learningObjective?.name }}</p>
        <div
          class="flex flex-col gap-2 min-h-[100%] max-h-[500px] overflow-auto scroll-style p-2"
        >
          <button
            v-for="(material, index) in onlyWatched()"
            :key="index"
            ref="materials"
            :class="`${
              currentMaterial?.id === material?.id ? 'bg-yellow-50' : 'bg-white'
            } w-full my-1 rounded-md`"
            :title="material?.name"
            @click="chooseMaterial(index)"
          >
            <div
              class="border border-l-8 border-h-primary-500 w-full rounded-md flex items-center justify-between p-4 gap-2"
            >
              <div class="flex items-center text-start gap-2 max-w-full">
                <v-icon
                  :name="materialsUtils.getIcon(material?.file?.mimetype)"
                  class="text-primary-400"
                  :scale="1.5"
                />
                <p class="break-words line-clamp-1">
                  {{ material?.name }}
                </p>
              </div>
              <v-icon
                v-if="material?.concluded"
                name="hi-solid-check-circle"
                class="text-green-500"
                :scale="1.2"
              />
            </div>
          </button>
        </div>
        <div 
          class="mt-2 p-2"
        >
          <Button class="btn-outline gap-2 w-full" @click="onCloseStudentMap">
            <v-icon name="md-openinnew" class="text-primary-400" />
            {{
              $t("labels.generic", {
                pt: "Ver todo mapa de conteúdo",
                en: "View full content map",
              })
            }}
          </Button>
        </div>
      </section>
    </OverlayPanel>
  </main>
</template>

<script lang="ts">
import { LearningObjective } from "@/models/learning-objective.model";
import { Material } from "@/models/material.model";
import { MaterialsUtils } from "@/utils/materials.util";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "historyMaterials",
  emits: ["onChooseMaterial", "onCloseStudentMap"],
  props: {
    materials: {
      type: Array as PropType<Material[]>,
    },
    currentMaterial: {
      type: Object as PropType<Material>,
    },
    learningObjective: {
      required: true,
      type: Object as PropType<LearningObjective>,
    },
    isAdaptativeLearning: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    materialsUtils(): MaterialsUtils {
      return new MaterialsUtils();
    },
  },
  methods: {
    chooseMaterial(index: number): void {
      this.$emit("onChooseMaterial", index);
      (this.$refs.panel as any).hide();
      window.scrollTo(0, 0);
    },
    scrollToActualItem(): void {
      var index = this.materials?.findIndex(
        (e) => e.id === this.currentMaterial?.id
      );

      setTimeout(() => {
        (this.$refs.materials as any)[index!!]?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }, 200);
    },
    onToggleFilter(event: any): void {
      (this.$refs.panel as any).toggle(event);
      this.scrollToActualItem();
    },
    onlyWatched(): Material[] {
      const allTrue = this.materials?.filter((e) => e.concluded == true);
      const allFalse = this.materials?.filter((e) => e.concluded == false);
      return this.checkDoneFalse(allTrue!!, allFalse!!);
    },
    checkDoneFalse(allTrue: Material[], allFalse: Material[]): Material[] {
      var result: Material[];
      if (allFalse?.length !== 0) {
        result = [...allTrue, allFalse[0]];
      } else {
        result = [...allTrue];
      }
      return result;
    },
    onCloseStudentMap(): void {
      this.$emit("onCloseStudentMap", true);
      (this.$refs.panel as any).hide();
    },
  },
});
</script>
